import {Injectable} from '@angular/core';
import {CanMatch, Route, UrlSegment} from '@angular/router';
import {AccessControlService} from '../access-control/access-control.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanMatch {

  constructor(private _accessControl: AccessControlService) {
  }

  /**
   * @description checks if logged in and allows the user to authorized route.
   * @returns boolean
   */
  public canMatch(route: Route, segments: UrlSegment[]): boolean {
    if (this._accessControl.isAuthorized()) {
      return true;
    } else {
      this._accessControl.logout();
      return false;
    }
  }
}
